import React from 'react';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ActionMenu from '@/components/actionmenu';
import usePrivateAction from '@/utils/usePrivateAction';
import { pinPost } from '@/apis/posts';
import { selectIsAdmin } from '@/store/modules/user';
import { invalidatePostFeed, syncPostMetrics } from '@/store/modules/posts';

const PostPinAction = ({ post, onChanged, children }) => {
  const admin = useSelector(selectIsAdmin);
  const dispatch = useDispatch();
  const { busy, run } = usePrivateAction();
  const pinned = Boolean(post.is_pinned);
  const eligible = post.status === 'active' && !post.completed_at && Date.parse(post.expire_time) > Date.now();
  const item = admin ? {
    key: 'pin', label: pinned ? '取消置顶' : '置顶帖子', disabled: !pinned && !eligible,
    disabledReason: '仅有效期内、尚未完成的开放帖子可以置顶',
    confirm: pinned ? '取消置顶后，首页将按正常顺序展示该帖子。' : '将此帖置于所属学校首页列表前方？推荐和附近招募的顺序保持不变。',
    onClick: () => run(async () => {
      const result = await pinPost(post.id, !pinned);
      if (String(result?.id) !== String(post.id) || typeof result.is_pinned !== 'boolean') throw new Error('置顶响应无效，请刷新帖子确认结果');
      return result;
    }, result => {
      dispatch(syncPostMetrics({ postId: post.id, post: result }));
      dispatch(invalidatePostFeed());
      onChanged(result);
      message.success(result.is_pinned ? '帖子已置顶' : '已取消置顶');
    }, '置顶操作失败，请刷新帖子后重试'),
  } : null;
  return children ? children(item, busy) : <ActionMenu label="更多操作" items={[item]} disabled={busy} />;
};

export default PostPinAction;
